import React, { useState, useCallback } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import moment from 'moment';
import { toast } from 'react-toastify';
import { MutableButton } from 'ui/MutableButton';
import { useSendRegularNeedPeriodReportsForMonthMutation } from 'schema/serverTypes';

interface SendReportsButtonProps {
  month: string;
  onSent?: () => void;
}

export const SendReportsButton = ({ month, onSent }: SendReportsButtonProps) => {
  const [open, setOpen] = useState(false);

  const [sendReports, { loading }] = useSendRegularNeedPeriodReportsForMonthMutation();

  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);

  const handleConfirm = useCallback(async () => {
    try {
      const result = await sendReports({ variables: { input: { month } } });
      if (result.data?.sendRegularNeedPeriodReportsForMonth.success !== false) {
        toast.success('Отправка отчётов запущена');
        setOpen(false);
        onSent?.();
      } else {
        toast.error('Не удалось отправить отчёты');
      }
    } catch {
      toast.error('Не удалось отправить отчёты');
    }
  }, [sendReports, month, onSent]);

  const monthLabel = moment(month).format('MMMM YYYY');

  return (
    <>
      <MutableButton loading={loading} color="primary" onClick={handleOpen}>
        Отправить отчёты
      </MutableButton>
      <Dialog open={open} onClose={handleClose} maxWidth="xs">
        <DialogTitle>Подтверждение</DialogTitle>
        <DialogContent>Отправить отчёты подопечных за {monthLabel}?</DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <MutableButton loading={loading} color="primary" onClick={handleConfirm}>
            Отправить
          </MutableButton>
        </DialogActions>
      </Dialog>
    </>
  );
};
